module.exports = __webpack_public_path__ + "media/images/flame-669dc9a1c2f24519ed782e4f04c37788.svg";